import * as React from "react";
export function Footer() {
    return (<div className="lg:fixed pin-b pin-l pin-r p-4 border-gray border-t bg-white z-20 leading-normal">
      <form onSubmit={e => e.preventDefault()}>
        <input type="text" placeholder="This is a real text box" className="w-full sm:w-64 bg-inactive border-gray border-2 p-2 text-black active:bg-transparent" id="real-text-box"/>
        <span className="ml-3 mt-3 lg:mt-0 block lg:inline">
          This is a <strong>real</strong> text box. Try to apply the knowledge
          you acquire in this guide with this <strong>totally real</strong> text
          box.
        </span>
        <button type="reset" className="ml-3 mt-3 lg:mt-0 inline-block lg:inline bg-primary text-white hover:bg-primary-lighter px-3 py-2 rounded">
          Reset real text box
        </button>
      </form>
    </div>);
}
//# sourceMappingURL=footer.jsx.map